export type LastSignInMethod = 'google' | 'apple' | 'password' | 'otp';

const LAST_SIGN_IN_METHOD_KEY = 'ofrontend.lastSignInMethod';

export function readLastSignInMethod(): LastSignInMethod | null {
  try {
    const raw = localStorage.getItem(LAST_SIGN_IN_METHOD_KEY)?.trim();
    return raw === 'google' || raw === 'apple' || raw === 'password' || raw === 'otp' ? raw : null;
  } catch {
    return null;
  }
}

export function persistLastSignInMethod(method: LastSignInMethod): void {
  try {
    localStorage.setItem(LAST_SIGN_IN_METHOD_KEY, method);
  } catch {
    /* quota / private mode */
  }
}
